<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{ name: 'Dashboard', path: '/manager/main', icon: 'ni layout-11 text-primary', }"
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Accounts',
            icon: 'ni add-27 text-green',
            path: '/manager/users'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Courses',
            icon: 'ni certificate text-info',
            path: '/courses'
          }"
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Classes',
            icon: 'ni show-room text-default',
            path: '/classes'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Homework',
            icon: 'ni homework',
            path: '/manager/homework'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Schedule',
            icon: 'ni event-confirm text-red',
            path: '/manager/schedule'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Resources',
            icon: 'ni filter-organization',
            path: '/manager/resources'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Invoices',
            icon: 'ni money-bag text-green',
            path: '/manager/payments'
          }"
        ></sidebar-item>

      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    }
  },
  mounted() {
    this.initScrollbar();
  }
};
</script>
<style lang="scss">
</style>
